import { ScrollArea } from "@circleco/compass/components/ScrollArea";
import { useLayoutEffect, useRef } from "react";

import { CircleAIAgentsSection } from "./CircleAIAgentsSection";
import { CircleAIBuildSection } from "./CircleAIBuildSection";
import { CircleAIDockNavSection } from "./CircleAIDockNavSection";
import { CircleAIDockRecentChatsSection } from "./CircleAIDockRecentChatsSection";
import { useBuildNavItems } from "./useBuildNavItems";
import { usePrimaryNavSectionWithBadge } from "./useDockNavSections";
import { useOpenBuildGroup } from "./useOpenBuildGroup";

const SCROLL_AREA_STYLE = {
  "--scroll-area-fade-color": "var(--color-background-secondary)",
} as React.CSSProperties;

export const CircleAIDockNavExpanded = () => {
  const primarySection = usePrimaryNavSectionWithBadge();
  const navItems = useBuildNavItems();
  const agentItems = navItems.filter(item => item.section === "agents");
  const buildItems = navItems.filter(item => item.section !== "agents");
  const { openGroupId, onToggleGroup } = useOpenBuildGroup(navItems);
  const viewportRef = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    viewportRef.current
      ?.querySelector("[data-dock-active]")
      ?.scrollIntoView({ block: "nearest" });
  }, []);

  return (
    <ScrollArea.Root
      scrollFades
      style={SCROLL_AREA_STYLE}
      className="relative h-full min-h-0"
    >
      <ScrollArea.Viewport ref={viewportRef} className="size-full">
        <div className="pt-1.5">
          <CircleAIDockNavSection section={primarySection} />
          <CircleAIDockRecentChatsSection />
          <CircleAIAgentsSection
            items={agentItems}
            openGroupId={openGroupId}
            onToggleGroup={onToggleGroup}
          />
          <CircleAIBuildSection
            items={buildItems}
            openGroupId={openGroupId}
            onToggleGroup={onToggleGroup}
          />
        </div>
      </ScrollArea.Viewport>
      <ScrollArea.Scrollbar orientation="vertical" />
    </ScrollArea.Root>
  );
};
